<template>
  <header class="header">
    <div class="header__container">
      <h1 class="header__title">Our Passion is Solar Energy and Sustainable Development</h1>
      <h4 class="header__subtitle">
        Energy supply and environmental problems present today's society with demanding tasks
      </h4>
      <div class="header__action">
        <router-link to="/about" class="button has-icon">
          Learn more
          <svg viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5.5H13M13 5.5L7 1M13 5.5L7 10" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
      </div>
    </div>
    <div class="header__arrow">
      <svg viewBox="0 0 32 39" fill="none" xmlns="http://www.w3.org/2000/svg" v-on:click="scrollTo('we-are-solar-energy')">
        <path d="M16.5 1V37.0261M16.5 37.0261L31 19.0131M16.5 37.0261L1.5 19.0131" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </header>
</template>

<script>
export default {
  name: 'hero-header',

  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
  },
};
</script>
